import { takeUntil } from 'rxjs/operators';
import { UntypedFormGroup } from '@angular/forms';
import { Authority } from 'src/app/constants/authority';
import { Component, Input, OnInit } from '@angular/core';
import { ClassInputType } from '../types/class-input-type';
import { Status } from 'src/app/core/services/http/general/enums/status';
import { Paging } from 'src/app/core/services/http/general/classes/paging';
import { AuthFactoryService } from 'src/app/core/services/auth/auth-factory.service';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { ActivityPriority } from 'src/app/core/services/http/activity-priority/interfaces/activity-priority';
import { ActivityPriorityService } from 'src/app/core/services/http/activity-priority/activity-priority.service';
import { ActivityPriorityType } from 'src/app/core/services/http/activity-priority/enums/activity-priority-type';

@Component({
  selector: 'app-priority-type-select',
  templateUrl: './priority-type-select.component.html'
})
export class PriorityTypeSelectComponent extends DestroyNotifierComponent implements OnInit {
  @Input() form: UntypedFormGroup | undefined;
  @Input() className: ClassInputType = 'app-input';
  activityPriorities: ActivityPriority[] | undefined;
  priorityUUID = '';
  isPrioritySet = false;

  constructor(
    private authFactoryService: AuthFactoryService,
    private activityPriorityService: ActivityPriorityService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadPriorities();
  }

  private filterPriorities() {
    if (!this.activityPriorities || !this.form) {
      return;
    }

    if(!this.isPrioritySet){
      this.priorityUUID = this.form?.controls.priority?.value;
      this.isPrioritySet = true;
    }

    const schoolUserAuthority = this.authFactoryService.service.getSchoolUserAuthority();
    const userRole = schoolUserAuthority?.role;

    const isPriorityTypeAdminMustAttend = this.activityPriorities.some(
      (priority) => priority.uuid === this.priorityUUID && priority.type === ActivityPriorityType.AdminMustAttend
    );

    this.activityPriorities = this.activityPriorities.filter((item: ActivityPriority) => {

    return isPriorityTypeAdminMustAttend
      ? item.type !== ActivityPriorityType.TeacherRequested
      : userRole === Authority.Admin
        ? item.type !== ActivityPriorityType.TeacherRequested
        : item.type !== ActivityPriorityType.AdminMustAttend &&
          item.type !== ActivityPriorityType.TeacherRequested;
    });
  }

  loadPriorities() {
    this.activityPriorityService
      .getAll(new Paging().getAllRecords(), {
        status: Status.Active,
        orderBy: 'type'
      })
      .pipe(takeUntil(this.destroyNotify))
      .subscribe((activityPriorities: ActivityPriority[]) => {
        this.activityPriorities = activityPriorities;
        //TODO: Remove settimeout
        setTimeout(()=>{
          this.filterPriorities();
        },1000)
      });
  }
}
